<div *ngIf="step == 1">
    <p class="mb-4">Please mention the Stop date</p>
    <mat-form-field class="form-group dark-input mb-2">
        <mat-label>Stop Date</mat-label>
        <input
            matInput
            [matDatepicker]="startDatePicker"
            [min]="minStartDate"
            [matDatepickerFilter]="dateFilter"
            [max]="endDate"
            [(ngModel)]="upcomingStatusDate"
            (dateChange)="onUpcomingStatusDateChanged($event.value)"
            name="stopDate"
        />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <div class="d-flex align-items-center justify-content-center">
        <button
            [disabled]="!isUpcomingDateWithinRange()"
            (click)="moveToStepTwo()"
            class="btn btn-md btn-gray-500"
        >
            Ok
        </button>
    </div>
</div>

<div *ngIf="step == 2">
    <h6 class="montserrat-medium text-gray-500 mb-2">{{ getTitle() }}</h6>
    <p class="mb-4" *ngIf="getDescription()">
        {{ getDescription() }}
    </p>
    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>Cancel</button>
        <button
            [disabled]="!canStopCampaign() || (!isAdmin && !isUpcomingDateWithinRange())"
            (click)="stopCampaign()"
            class="btn btn-md btn-gray-500"
        >
            Yes
        </button>
    </div>
</div>
